import _objectSpread from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _classCallCheck from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/get.js";
import _getPrototypeOf from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/createSuper.js";

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Entity } from '@rest-hooks/normalizr';
var DefinedMembersKey = Symbol('Defined Members');
var UniqueIdentifierKey = Symbol('unq');
/** Immutable record that keeps track of which members are defined vs defaults. */

var EntityRecord = /*#__PURE__*/function (_Entity) {
  _inherits(EntityRecord, _Entity);

  var _super = _createSuper(EntityRecord);

  function EntityRecord() {
    _classCallCheck(this, EntityRecord);

    return _super.apply(this, arguments);
  }

  _createClass(EntityRecord, [{
    key: "toString",
    value: function toString() {
      // we don't make _unq a member so it doesn't play a role in type compatibility
      return this[UniqueIdentifierKey];
    }
    /** Factory method to convert from Plain JS Objects.
     *
     * @param [props] Plain Object of properties to assign.
     * @param [parent] When normalizing, the object which included the record
     * @param [key] When normalizing, the key where this record was found
     */

  }], [{
    key: "fromJS",
    value: function fromJS() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (props instanceof EntityRecord) {
        props = props.constructor.toObjectDefined(props);
      }

      var instance = _get(_getPrototypeOf(EntityRecord), "fromJS", this).call(this, props);

      Object.defineProperty(instance, DefinedMembersKey, {
        value: _objectSpread({}, props),
        writable: false
      }); // a 'unique' identifier to make referential equality comparisons easy

      Object.defineProperty(instance, UniqueIdentifierKey, {
        value: "".concat(Math.random()),
        writable: false
      });
      return instance;
    }
    /** Creates new instance copying over defined values of arguments */

  }, {
    key: "mergeRecord",
    value: function mergeRecord(existing, incoming) {
      var props = Object.assign(this.toObjectDefined(existing), this.toObjectDefined(incoming));
      return this.fromJS(props);
    }
    /** Whether key is non-default */

  }, {
    key: "hasDefined",
    value: function hasDefined(instance, key) {
      return Object.hasOwnProperty.call(instance[DefinedMembersKey], key);
    }
    /** Returns simple object with all the non-default members */

  }, {
    key: "toObjectDefined",
    value: function toObjectDefined(instance) {
      return instance[DefinedMembersKey];
    }
    /** Returns array of all keys that have values defined in instance */

  }, {
    key: "keysDefined",
    value: function keysDefined(instance) {
      return Object.keys(instance[DefinedMembersKey]);
    }
    /** Used by denormalize to set nested members */

  }, {
    key: "set",
    value: function set(entity, key, value) {
      entity[key] = value;
      entity[DefinedMembersKey][key] = value;
    }
  }]);

  return EntityRecord;
}(Entity);

export { EntityRecord as default };